import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { ModalService } from "../../services/modal/modal.service";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-contact",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./contact.component.html",
  styleUrl: "./contact.component.scss",
})
export class ContactComponent implements OnInit, OnDestroy {
  visible = false;

  testNoneOrDisplay = this.visible ? "flex" : "none";

  private subscription: Subscription | undefined;

  constructor(private modalService: ModalService) {}

  ngOnInit() {
    this.subscription = this.modalService.contactModal$.subscribe((visible) => {
      this.visible = visible;
    });
  }

  closeModal(): void {
    this.modalService.toggleContactModal();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
